export default __webpack_public_path__ + "static/media/borku-mark.57757394.png";